import React, { useEffect, useRef, useState } from 'react'
import { Box } from 'elements'
import { NAV_BAR_WIDTH } from './NavBar'
import { HEADER_HEIGHT } from './Header'
import PageContent from './PageContent'
import AppBanners from './AppBanners'

export default function PageBody({ renderHeader, renderContent, ...props }) {
  const [headerHeight, setHeaderHeight] = useState(HEADER_HEIGHT)
  const headerRef = useRef()

  useEffect(() => {
    setHeaderHeight(headerRef?.current?.clientHeight)
  }, [headerRef])

  return (
    <Box
      display="flex"
      flex="1 1 auto"
      flexDirection="column"
      overflow="auto"
      bg="background.1"
      height="100%"
      pt={`${headerHeight}px`}
      pl={`${NAV_BAR_WIDTH}px`}
      {...props}
    >
      <Box ref={headerRef} position="absolute" top="0" left={`${NAV_BAR_WIDTH}px`} right="0">
        <AppBanners />
        {renderHeader()}
      </Box>
      <PageContent>{renderContent()}</PageContent>
    </Box>
  )
}
